const Scripts = (): React.JSX.Element | null => {
  return null;
};

export default Scripts;
